import React from 'react';
import { useDispatch } from 'react-redux';
import { t } from 'i18next';
import { Modal } from 'react-bootstrap';
import { FaRegCheckCircle, FaRegTimesCircle } from 'react-icons/fa';
import { approvalMediciens } from '../../../redux/mediciens';

const ConfirmDialog = ({ payload, handleClose, fetchMedicines }) => {
	const dispatch = useDispatch();

	const handleConfirm = async() => {
		await dispatch(approvalMediciens(payload)).unwrap();
		handleClose();
		fetchMedicines();
	};

	return (
		<Modal show={!!payload} onHide={handleClose} centered backdrop="static">
			<Modal.Body className="text-center m-1">
				<h5>{t(`MEDICIENS.CONFIRM.CONFIRM_${payload?.action?.toUpperCase()}`)}</h5>
				<p className="text-muted mt-2">{t('MEDICIENS.CONFIRM.ACTION_WARNING')}</p>
				<div className="d-flex justify-content-center gap-3 mt-4">
					<FaRegCheckCircle
						style={{ color: 'green', cursor: 'pointer' }}
						size={40}
						onClick={handleConfirm}
					/>
					<FaRegTimesCircle
						style={{ color: 'red', cursor: 'pointer' }}
						size={40}
						onClick={handleClose}
					/>
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default ConfirmDialog;